import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.element.addEventListener("input", this.refreshSize.bind(this));

    this.originalWidth = this.element.offsetWidth;
    this.buffer = parseInt(this.element.getAttribute("data-buffer")) || 40;

    this.refreshSize();
  }

  refreshSize() {
    const input = this.element;

    // Create a temp element, copy the input's text to it, and then measure the width of the div.
    let tempElement = document.createElement('canvas').getContext('2d');
    const computedStyle = window.getComputedStyle(input);
    tempElement.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
    const textWidth = tempElement.measureText(input.value).width;

    // Set the input's width to the width of the text plus some padding
    const newSize = Math.max(textWidth + this.buffer, this.originalWidth);
    input.style.width = `${newSize}px`;

    // Remove that temporary element
    tempElement = null;
  }
}